import { render, staticRenderFns } from "./CampusForm.vue?vue&type=template&id=28549488&scoped=true"
import script from "./CampusForm.vue?vue&type=script&lang=js"
export * from "./CampusForm.vue?vue&type=script&lang=js"
import style0 from "./CampusForm.vue?vue&type=style&index=0&id=28549488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28549488",
  null
  
)

export default component.exports